package article.spring

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.dp


const val SPRING_VS_DURATION = "2e27f8038a095cb1754495c998f4363b9e7c74b343345abf2c8f2079d8d5214a"

@Composable
fun SpringVsDuration() {

    SpringGrid {

        val density = LocalDensity.current
        var width by remember { mutableStateOf(10) }
        val widthDp by remember {
            derivedStateOf {
                with(density) {
                    width.toDp()
                }
            }
        }

        var toTheLeft by remember { mutableStateOf(true) }
        val offset = if (toTheLeft) 0.dp else widthDp - 50.dp - 32.dp

        val springOffset by animateDpAsState(
            targetValue = offset,
            animationSpec = spring(
                stiffness = 35f
            )
        )

        val tweenOffset by animateDpAsState(
            targetValue = offset,
            animationSpec = tween(1_000)
        )

        Column(
            Modifier
                .onSizeChanged { width = it.width }
                .padding(16.dp)
                .fillMaxSize(),
            verticalArrangement = Arrangement.SpaceAround
        ) {


            Orb(
                modifier = Modifier
                    .offset(x = springOffset)
                    .size(50.dp)
            )

            Box(
                modifier = Modifier
                    .offset(x = tweenOffset)
                    .size(50.dp)
                    .background(Color.White.copy(alpha = .72f), CircleShape)
            )


            SpringButton(
                modifier = Modifier.align(Alignment.CenterHorizontally),
                onClick = { toTheLeft = !toTheLeft }
            ) {
                Text("Animate", color = Color.Black)
            }


        }
    }

}